export const stageLabel = (stage?: string) =>
  stage && stage !== 'NO_AGRI_INPUT_STAGE'
    ? stage
        .replace(/^AGS_/, '')
        .split('_')
        .map((w) => w.charAt(0) + w.slice(1).toLowerCase())
        .join(' ')
    : '';
